import { render, staticRenderFns } from "./SubjectPendencies.vue?vue&type=template&id=59be1ea6&scoped=true&"
import script from "./SubjectPendencies.vue?vue&type=script&lang=js&"
export * from "./SubjectPendencies.vue?vue&type=script&lang=js&"
import style0 from "./SubjectPendencies.vue?vue&type=style&index=0&id=59be1ea6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59be1ea6",
  null
  
)

export default component.exports